export const getVisible = (state) => state.picture_swiper.visible;
export const getPictures = (state) => state.picture_swiper.pictures;
export const getIndex = (state) => state.picture_swiper.index;